import { useState, useEffect, useRef } from "react";
import { useLazyQuery, useMutation } from "@apollo/client";
import styled from "styled-components";
import Layout from "../../components/Layout";
import {
  DatosContacto,
  Siniestro,
} from "../../components/pageComponents/ContratosYSiniestros";
import { Button, SearchBar } from "../../components/ui";
import {
  GET_CONTRACTS_STATUS,
  GET_CONTRACT_BY_ID_CLIENT,
  UPDATE_STATUS_CONTRACT,
} from "../../services/contract/contracts";
import { GET_CLIENTS_BY_NAME } from "../../services/clients";
import ModalWrapper from "../../components/ModalContainer";
import { ModalRegistroPago } from "../../components/pageComponents/CapturaSiniestro";
import { useSiniester } from "../../redux/siniesterReducer";
import { useContract } from "../../redux/contractReducer";

//---- HEADER ----//
const HeaderWrapper = styled.div`
  background-color: var(--primary-royal-blue);
  display: grid;
  place-content: center;
`;
const Header = styled.div`
  width: 1200px;
  background-color: var(--primary-royal-blue);
  padding: 56px 0;
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  @media only screen and (max-width: 1280px) {
    width: 90vw;
  }
  @media only screen and (max-width: 768px) {
    width: 94vw;
    display: block;
    gap: 20px;
  } ;
`;

const SearchContainer = styled.div`
  display: flex;
  gap: 40px;
  @media only screen and (max-width: 768px) {
    flex-direction: column;
  } ;
`;

const Title = styled.h1`
  color: #fff;
  line-height: 26px;
  @media only screen and (max-width: 768px) {
    width: 100%;
    display: block;
    gap: 20px;
    margin-bottom: 20px;
    line-height: 32px;
  } ;
`;

//---- MODULE ----//
const ModuleWrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  position: relative;
  &:after {
    background-color: var(--primary-royal-blue);
    content: "";
    top: 0;
    height: 200px;
    width: 100%;
    position: absolute;
    z-index: -1;
  }
`;

//---- SINIESTROS ----//
const SiniestrosContainer = styled.div``;

//---- MODAL ----//
const ModalDescription = styled.p`
  font-size: 14px;
  color: var(--neutrals-light-gray);
  text-align: center;
  margin-bottom: 24px;
`;

const ModuleTitle = styled.p`
  color: var(--neutrals-charcoal);
  font-size: 24px;
  font-weight: 700;
  margin-bottom: 20px;
`;

export default function ContratosYSiniestros() {
  const [showModal, setShowModal] = useState(false);
  const [isBlockedSiniester, setIsBlockedSiniester] = useState(true);
  // MODAL PAYMENTS
  const [showModalPayments, setShowModalPayments] = useState(false);

  const [filterByClient, setFilterByClient] = useState("");
  const [filterByContract, setFilterByContract] = useState("");
  const [datClient, setDatClient] = useState([]);
  const [datContract, setDatContract] = useState([]);
  const [dataSelected, setDataSelected] = useState([]);
  const [selectedContract, setSelectedContract] = useState([]);
  const { resetSiniester } = useSiniester();
  const { contractState, setContract, resetContract } = useContract();
  const [status, setStatus] = useState("");
  const [isDisabled, setIsDisabled] = useState(true);
  const [contractStatus, setContractStatus] = useState([]);
  // Queries
  const [getAllContractByIdClient] = useLazyQuery(GET_CONTRACT_BY_ID_CLIENT, {
    fetchPolicy: "no-cache",
    onCompleted({ getAllContractByIdClient }) {
      if (getAllContractByIdClient.statusCode === 200) {
        const resultData = JSON.parse(getAllContractByIdClient.response);
        setDatContract(resultData);
      }
    },
  });

  const [getClientsByName] = useLazyQuery(GET_CLIENTS_BY_NAME, {
    fetchPolicy: "no-cache",
    onCompleted({ getClientsByName }) {
      if (getClientsByName.statusCode === 200) {
        const resultData = JSON.parse(getClientsByName.response);
        setDatClient(resultData);
      }
    },
  });

  const [getContractStatus] = useLazyQuery(GET_CONTRACTS_STATUS, {
    fetchPolicy: "network-only",
    onCompleted({ getContractStatus }) {
      if (getContractStatus.statusCode === 200) {
        const result = JSON.parse(getContractStatus.response);
        const dataOptionClient = result.map((cliente) => ({
          titleNameArr: "estatus_contrato_id",
          label: cliente.valor,
          value: cliente.estatus_contrato_id,
        }));
        setContractStatus((data) => [...dataOptionClient]);
      }
    },
    onError(err) {
      console.log("Error: ", err);
    },
  });
  const [updateStatusContract] = useMutation(UPDATE_STATUS_CONTRACT, {
    fetchPolicy: "network-only",
    onCompleted({ updateStatusContract }) {
      if (updateStatusContract.statusCode === 200) {
        const statusFind = contractStatus.find((st) => st.label === status);
        setContract({
          ...contractState,
          estatus_contrato_id: statusFind.valor,
          valor_est_cont: statusFind.label,
        });
      }
    },
  });
  const handleSearchClient = (valueInput) => {
    getClientsByName({
      variables: {
        nombre: valueInput,
      },
    });
    setIsDisabled(false);
  };

  const handleSearchContract = () => {
    if (Object.keys(dataSelected).length > 0) {
      resetSiniester();
      getAllContractByIdClient({
        variables: {
          idClient: dataSelected.cliente_id,
          nombre: filterByContract,
        },
      });
    }
    clearValue();
  };

  useEffect(() => {
    if (filterByContract) handleSearchContract();
    // eslint-disable-next-line  react-hooks/exhaustive-deps
  }, [filterByContract]);

  const siniestroRef = useRef(null);

  function clearValue() {
    siniestroRef?.current?.clearValue();
    setIsBlockedSiniester(true);
  }
  useEffect(() => {
    getContractStatus();
    // eslint-disable-next-line  react-hooks/exhaustive-deps
  }, []);
  const updateStatus = () => {
    const statusFind = contractStatus.find((st) => st.label === status);
    updateStatusContract({
      variables: {
        idContract: +contractState.id,
        idStatus: +statusFind.value,
      },
    });
    setShowModal(false);
  };
  useEffect(() => {
    if (contractState?.noReset === true) {
      setContract({ ...contractState, noReset: false });
    } else {
      resetContract();
    }
    // eslint-disable-next-line  react-hooks/exhaustive-deps
  }, []);
  return (
    <>
      <ModalWrapper
        showModal={showModal}
        closeModal={() => setShowModal(false)}
      >
        <ModalDescription>
          <ModuleTitle>Cambiar Estatus</ModuleTitle>
          ¿Estas seguro que quieres cambiar tu estatus?
        </ModalDescription>
        <Button
          text="Sí, cambia de estatus"
          style={{ margin: "0 auto", display: "flex" }}
          onClick={updateStatus}
        />
      </ModalWrapper>
      {/* MODAL PAYMENTS */}
      <ModalWrapper
        showModal={showModalPayments}
        closeModal={() => setShowModalPayments(false)}
      >
        <ModuleTitle>Registro de Pago</ModuleTitle>
        <ModalRegistroPago />
      </ModalWrapper>
      <Layout>
        <HeaderWrapper>
          <Header>
            <Title>Archivo de Contratos y Siniestros</Title>
            <SearchContainer>
              <SearchBar
                placeholder={"Filtrar por cliente"}
                value={filterByClient}
                setValue={setFilterByClient}
                dataSearched={datClient}
                setDataSearched={setDatClient}
                onChange={handleSearchClient}
                setDataSelected={setDataSelected}
              />
              <SearchBar
                disabled={isDisabled}
                placeholder={"Filtrar por contrato"}
                value={filterByContract}
                setValue={setFilterByContract}
                dataSearched={datContract}
                setDataSearched={setDatContract}
                setDataSelected={setSelectedContract}
              />
            </SearchContainer>
          </Header>
        </HeaderWrapper>
        <ModuleWrapper>
          <DatosContacto
            modal={showModal}
            setModal={setShowModal}
            dataContact={selectedContract}
            setStatus={setStatus}
          />
          <SiniestrosContainer>
            <Siniestro
              siniestroRef={siniestroRef}
              onOpenModal={setShowModalPayments}
              dataSelected={selectedContract}
              isBlockedSiniester={isBlockedSiniester}
              setIsBlockedSiniester={setIsBlockedSiniester}
            />
          </SiniestrosContainer>
        </ModuleWrapper>
      </Layout>
    </>
  );
}
